import React from 'react';

import S from './Videos.module.css';

export const VideosImg = () => (
  <div className={S.root}>
    <div className={S.top}>
      <hr className={S.hr1} />
      <hr className={S.hr2} />
      <hr className={S.hr3} />
      <hr className={S.hr4} />
      <hr className={S.hr5} />
      <hr className={S.hack} />
    </div>
    <div className={S.bottom}>
      <b className={S.c1}></b>
      <b className={S.c2}></b>
      <b className={S.c3}></b>
      <b className={S.c4}></b>
    </div>
  </div>
);
